<template>
  <v-app class="app-default" :class="{'app-transparent':transparent, 'hide-nav': hideNav}">
    <v-toolbar height="40" class="header" dark fixed>
      <v-layout fill-height align-center :class="{'layout-wrap':!breakpoint.xs}">
        <v-toolbar-side-icon @click.stop="drawer=!drawer" class="bar-icon hidden-md-and-up"></v-toolbar-side-icon>
        <img src="/images/company-logo.png" width="43" height="12" style="margin-right: 12px;">
        |
        <v-toolbar-title class="caption">企业员工保险服务专家</v-toolbar-title>
        <v-spacer></v-spacer>
        <span
          class="caption caption-color hidden-sm-and-down"
          style="margin-right: 15px;"
        >客服与投诉电话：4006-234-345</span>
        <a
          href="https://insurance-enterprise.yicaibaoxian.com/user/login"
          target="_blank"
          class="caption"
          style="margin-right: 15px; color: #fff; text-decoration: none;"
        >登录</a>
        <a
          href="https://insurance-enterprise.yicaibaoxian.com/user/register"
          target="_blank"
          class="caption"
          style="margin-right: 15px; color: #fff; text-decoration: none;"
        >注册</a>
      </v-layout>
    </v-toolbar>

    <AppNav v-model="drawer" v-if="!hideNav"></AppNav>

    <v-content class="content">
      <router-view></router-view>
    </v-content>

    <AppFooter/>
    <CLogin></CLogin>
  </v-app>
</template>

<script>
import AppFooter from "./components/AppFooter";
import AppNav from "./components/AppNav";

export default {
  name: "default",
  components: {
    AppFooter,
    AppNav,
  },
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    transparent() {
      return this.$route.meta.navTransparent || false;
    },
    hideNav() {
      return this.$route.meta.hideNav || false;
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    userName() {
      if (this.user) {
        return (
          this.user.realName ||
          this.user.userAccount.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
        );
      }
      return "未知";
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.replace({ name: "home" });
        this.$router.go(0)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$toolbar-height: 40px;
$nav-height: 80px;
img.nav-logo-img{
  width: 25px;
}
.app-default {
  .header {
    .v-toolbar__content {
      padding: 0;
    }
  }
  .content {
    margin-top: $toolbar-height + $nav-height;
  }
}
.app-transparent {
  .content {
    margin-top: $toolbar-height;
  }
}
.hide-nav {
  .content {
    margin-top: $toolbar-height;
  }
}
.v-toolbar__title:not(:first-child) {
  margin-left: 12px;
}
</style>
